import { Decoder, field, string, succeed } from 'jsonous';
import { resourceDecoder } from '../Resource/Decoders';
import { VisualizationToken, VisualizationTokenResource } from './Types';

const visualizationTokenResponseDecoder: Decoder<VisualizationToken> = succeed({}).assign(
  'value',
  field('value', string),
);

export const visualizationTokenResourceDecoder: Decoder<VisualizationTokenResource> =
  resourceDecoder(visualizationTokenResponseDecoder);
